import { LoadingButton } from '@mui/lab';
import { Typography, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { ITheme } from 'types/theme';

interface IWizardPrimaryButtonProps {
	disabled: boolean;
	onClick: () => void;
	text?: string;
}

const WizardPrimaryButton: FC<IWizardPrimaryButtonProps> = ({
	disabled,
	onClick,
	text
}) => {
	const [loading, setLoading] = React.useState(false);
	const { palette } = useTheme<ITheme>();

	let backgroundStyle = {};
	if (!disabled) {
		backgroundStyle = {
			background: palette.brand.descopeGradient(palette, 90, 0, undefined, 100)
		};
	}

	const handleClick = React.useCallback(() => {
		setLoading(true);
		onClick();
	}, [onClick]);

	return (
		<LoadingButton
			variant="contained"
			data-testid="wizard-next-button"
			onClick={handleClick}
			disabled={disabled}
			loading={loading}
			sx={{
				borderRadius: 44,
				paddingX: 6,
				...backgroundStyle
			}}
		>
			<Typography
				variant="body1"
				color="primary.contrast"
				whiteSpace="nowrap"
				textTransform="uppercase"
			>
				{text || intl.tr('wizard.phase.next.button')}
			</Typography>
		</LoadingButton>
	);
};

WizardPrimaryButton.defaultProps = {
	text: ''
};

export default WizardPrimaryButton;
